import { EntityName } from 'modules/api/locHub/entity/name/name';
import React, { ReactElement } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NameInput } from '../../Common/Name/Name';
import { AutomationNameInputI18n } from './I18n';

interface Props {
  register: UseFormMethods['register'];
  errors: UseFormMethods['errors'];
  value?: string;
}

export const AutomationNameInput: React.FC<Props> = ({ value, register, errors }): ReactElement => {
  const [t] = useTranslation();
  const maxLength = 256;
  const namespace = AutomationNameInputI18n.configuration.namespace;
  const label = t(`${namespace}.label`);
  const placeholder = t(`${namespace}.placeholder`);
  const validationMaxLengthError = t(`${namespace}.validationMaxLengthError`, { maxLength });
  const validationRequiredError = t(`${namespace}.validationRequiredError`);
  return (
    <NameInput
      entity={EntityName.AUTOMATION}
      value={value}
      maxLength={maxLength}
      register={register}
      errors={errors}
      texts={{
        label,
        placeholder,
        validationMaxLengthError,
        validationRequiredError,
      }}
    />
  );
};
